module.exports = __webpack_public_path__ + "static/media/JUSTSans-Regular.6f3c78e7.woff2";